import React, { useEffect } from 'react';
import { Skeleton, Typography } from 'fronton-react';
import { TData } from 'entries/common/widgets/saved-project-configurations-list/context';
import { useSearchSavedConfigurations } from '../common/hooks/use-search-configurations';
import { getShouldShowProjects } from './helpers/get-should-show-projects';
import { SavedProjectsCarousel } from './components/saved-projects-carousel';
import { SavedProjectsEmptyState } from './components/saved-projects-empty-state';
import { Container } from './styles';
import { CALCULATORS_LAMINATE_CLOSE_CONFIGURATION_EVENT } from './constants';

export const SavedProjectConfigurationsListPage = ({ data }: { data: TData }) => {
  const { presaleProps, isCarouselShown, api, authorizedCustomerId, unauthorizedCustomerId } = data;
  const hasPresaleProps = Boolean(presaleProps);
  const shouldShowProjects = getShouldShowProjects({ isCarouselShown, presaleProps });

  const {
    configurationItems,
    isResponseEmpty,
    isLoading,
    isError,
    isLoaded,
    getConfigurations,
  } = useSearchSavedConfigurations({
    isRequestAvailable: shouldShowProjects,
    apiMethods: api,
    authorizedCustomerId,
    unauthorizedCustomerId,
    onSearchConfigurationsError: presaleProps?.onSearchConfigurationsError,
  });

  useEffect(() => {
    const cb = () => {
      getConfigurations();
    };

    document.body.addEventListener(CALCULATORS_LAMINATE_CLOSE_CONFIGURATION_EVENT, cb);

    return () => {
      document.body.removeEventListener(CALCULATORS_LAMINATE_CLOSE_CONFIGURATION_EVENT, cb);
    };
  }, [getConfigurations]);

  const isContentLoading = isLoading || !isLoaded;

  if (!shouldShowProjects || isError || (!hasPresaleProps && isResponseEmpty)) {
    // eslint-disable-next-line no-console
    console.warn('[SavedProjectConfigurationsListPage] hidden due to unavailable data state', {
      shouldShowProjects,
      isResponseEmpty,
      isError,
    });
    return null;
  }

  const showEmptyState = hasPresaleProps && !isContentLoading && isResponseEmpty;
  const showCarousel = !isContentLoading && !isResponseEmpty;

  return (
    <Container>
      <Skeleton variant="control" showLoading={isContentLoading} width="300px" height="24px">
        {hasPresaleProps ? (
          <Typography variant="h2" color="text-primary">
            Сохранённые расчёты
          </Typography>
        ) : (
          <Typography size="overline" variant="m">
            Сохранённые расчёты
          </Typography>
        )}
      </Skeleton>
      {isContentLoading ? <Skeleton variant="control" showLoading width="100%" height="164px" /> : null}
      {showEmptyState ? <SavedProjectsEmptyState /> : null}
      {showCarousel ? (
        <SavedProjectsCarousel
          configurations={configurationItems}
          onProjectClick={presaleProps?.onProjectClick}
          destroySlider={Boolean(presaleProps)}
        />
      ) : null}
    </Container>
  );
};
